<template>
    <div id="app">
        <el-container>
            <el-header class="div-header">
				<Header />
				<el-divider class="header-divider"></el-divider>
			</el-header>

            <div class="main-div">
				<el-container class="main-div parentDiv">
					<splitpanes class="default-theme defaultStyle custom-splite">
						<pane size="100" class="SideBarLeft">
                        <!--SID1013 Body Part-->
							<template>
								<el-container >
									
									<div class="SID1013__UserListScreen">
                                        <!-- Breadcrumb section -->
										<el-breadcrumb separator-class="el-icon-arrow-right" class="UserListScreenLink">
											<el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
											<el-breadcrumb-item :to="{ path: '' }">ユーザー一覧</el-breadcrumb-item>
										</el-breadcrumb>
                                            <el-form class="EmailDestinationReg"  label-width="auto">
                                                <el-form-item class="marginCustomClass" enctype="multipart/form-data">
													<span class="mandatoryMark">*</span> <span class="spanLabel">ユーザー一括登録</span>
													
                                                    <el-upload
														class="upload-demo"
														drag
														action="https://jsonplaceholder.typicode.com/posts/"
														:auto-upload='false'
														ref="upload">
														<i class="el-icon-upload"></i>
														<div class="el-upload__text">ここにファイルをドロップするか、<em>クリックしてファイルを選択してください。</em></div>
													</el-upload>
                                                </el-form-item>
                                                <el-form-item>
													<!-- // 2023/03/27  #14161  START -->
                                                    <el-button type="primary"  plain class="RegButton" @click="successonsubmit()" :disabled="Buttonpressed == 1">登録</el-button>
													<!-- // 2023/03/27  #14161  END -->
												</el-form-item>
												<!--Change CK for backlog ID 1605 csv select error msg-->  
												<span class="alertSpan">{{ Errortext }}</span> 
												<!--Change CK for backlog ID 1605 failure part-->
												<div title="確認" v-show="dialogTableVisible" class="alertbox_1013">
										<ul class="alert_1013">
											<li class="ErrorCSV">{{ getresponseMessage }}</li>
											<li v-for="(item,index) in csvuploadErrorList" v-bind:key="index" class="ErrorCSV">{{item}}</li>
										</ul>	
									</div>                            										
												<el-form-item class="el-lbl-content" label="ユーザー一括登録・個別登録">
												<el-button type="primary" plain class="RegButton-1" @click="csvdownload()">CSV出力</el-button>
												</el-form-item>								
                                            <el-form-item class="select-class" label="ユーザーグループ" prop="value">
                                            <el-select v-model=form.value  id="selected_id" @change="handleChange($event)" class="UserListSecectOption">
											<el-option
											v-for="item in getdropdownResult1013"
											:key="item.user_group_id"
											:label="item.user_group_name"
											:value="item.user_group_id">
											</el-option>
										</el-select>
										<el-button type="primary" class="button-userlist" plain   @click="sendDropdownData()">検索</el-button>
                                            </el-form-item>
                                        </el-form>
										<el-divider class="header-divider"></el-divider>
										<section class="button-underDividerTop">
										<el-button type="primary" class="button-underDivider2"  plain @click="add()">追加</el-button>
										<el-button type="danger" class="button-underDivider2" plain @click="open">削除</el-button>
										<el-button @click="gototop" type="info" plain>戻る</el-button>
										</section>
										<section>
											<el-table
											v-loading="loading"
											border
												ref="multipleTable"
												:data="getTableResult1013"
												style="width: 100%"
												@selection-change="handleSelectionChange"
												class="first_table"	>
												<el-table-column  type="selection" width="60"> </el-table-column>
												<el-table-column label="編集" fixed="left"  min-width="100">
													<template slot-scope="scope">
													<el-button  type="primary" plain @click="editdata(scope.row)">編集</el-button>
													</template>
												</el-table-column>
												<el-table-column prop="user_group_name" label="ユーザーグループID" min-width="350">
												</el-table-column>
												<el-table-column prop="user_id" label="ユーザーID" min-width="350">
												</el-table-column>
												<el-table-column
													min-width="200"
													prop="name"
													label="ユーザー名">
												</el-table-column>
												<el-table-column
													min-width="200"
													prop="login_stop_flag"
													label="利用停止">
												</el-table-column>
												<el-table-column
													min-width="150"
													prop="mc_user_authority"
													label="EL記事利用権限">
												</el-table-column>
												<el-table-column
													min-width="300"
													prop="sc_user_authority"
													label="日経利用権限">
												</el-table-column>
												<el-table-column
													min-width="150"
													prop="user_authority"
													label="ユーザ種別">
												</el-table-column>
												<el-table-column
													min-width="200"
													prop="topics_creation_flag"
													label="トピックスユーザー">
												</el-table-column>
												<el-table-column
													min-width="200"
													prop="pass_change_stop_flag"
													label="パスワード変更可能">
												</el-table-column>
												<el-table-column
													min-width="150"
													prop="sc_user_id"
													label="日経ユーザID">
												</el-table-column>
												<!-- 2026/06/15  生成AI連携商用版対応  START -->
												<el-table-column
													min-width="200"
													prop="use_ai_service_flag"
													label="AIサービス利用可能">
												</el-table-column>
												<!-- 2026/06/15  生成AI連携商用版対応  END -->
												
											</el-table>
										</section>
										<section class="button-underDividerBottom">
										<el-button type="primary" class="button-underDivider2" @click="add()"  plain>追加</el-button>
										<el-button class="button-underDivider2"  type="danger" plain @click="open">削除</el-button>
										<el-button @click="gototop" type="info" plain>戻る</el-button>
										<span class="buttonSpan">{{ text }}</span>
										</section>
									</div>						
								</el-container>
							</template>
                        <!--SID1013 Body Part End-->
						</pane>
						
						<pane class="SideBarRight">
							<SideBar class="SidePane" />
						</pane>
					</splitpanes>
				</el-container>
			</div>

            <el-container class="footer-div">
				<el-footer class="footer-element">
					<FooterComponent />
				</el-footer>
			</el-container>
        </el-container>
    </div>
</template>

<script>
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import router from '../../router';
import json from '../../components/config.json';
const newArr = {};
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";

export default {
	name: "UserGroupList",
	props: {
   
	},
	components: {
		Header,
		SideBar,
		FooterComponent,
		Splitpanes,
		Pane
	},
	data() {
      return {
			// 2023/03/27  #14161  START
			Buttonpressed: 0,
			// 2023/03/27  #14161  END
			loading: false,
			form: {
				value: ''
			},
			text: '',
			Errortext: '',
			dialogTableVisible: false
			
		}
		
	},
	methods:{ 
	open() {
		this.$LogButtonEvent("1013","Delete");
		this.$LogMethodIN("1013","open");
		//  Change CK for backlog ID 1605
        this.dialogTableVisible = false;
        this.Errortext="";
	if(this.$refs.multipleTable.selection.length > 0)
	{	
        this.$confirm(json["1013_delete_confirm_message"], json["1013_delete_confirm_message_title"], {
		showCancelButton: true,
        confirmButtonText: 'OK',
		cancelButtonText: 'キャンセル',
		customClass:'increase-width',

		}).then(() => {
			var DelArrayLength = this.$refs.multipleTable.selection.length;
			var DelArray =this.$refs.multipleTable.selection;
			
			var deletDetails;
			var tableContent_final=[];
			
            for(var i=0;i<DelArrayLength;i++){
					
					var tabledata_inner = {};

					tabledata_inner.user_group_id = DelArray[i].user_group_id;
					tabledata_inner.user_id = DelArray[i].user_id;
					
				
				tableContent_final.push(tabledata_inner);
				
			}
			deletDetails = {
				
				user_info: tableContent_final
			};
				this.$store.dispatch('communication1013/tableDelete',deletDetails).then(()=>{
					this.$alert(this.getDeleteResponseMsg, "削除", {
				confirmButtonText: 'OK',
				
			});
		});
			
        })
	}
	else
	{
		this.$alert(json["1013_checkbox_not_check_message"], json["1013_checkbox_not_check_message_title"], {
                  confirmButtonText: 'OK'
         }); 
	}
	this.$LogMethodOut("1013","open");
	},
	handleSelectionChange(val){
        //  Change CK for backlog ID 1605
         this.dialogTableVisible = false;
         this.Errortext="";
	newArr.value=  val;
	
	},
	// function is back to the top page
	gototop() {
		this.$LogButtonEvent("1013","Return");
		this.$LogMethodIN("1013","gototop");
		//  Change CK for backlog ID 1605
        this.dialogTableVisible = false;
        this.Errortext="";
		router.push({name:"Home"});
		this.$LogMethodOut("1013","gototop");
		},
		// pass the parameter and redirect to the 1014 page.
	add(){
		this.$LogButtonEvent("1013","Add");
		this.$LogMethodIN("1013","add");
		//  Change CK for backlog ID 1605
        this.dialogTableVisible = false;
        this.Errortext="";
		router.push({name:"1014",params:{Details : ""}});
		this.$LogMethodOut("1013","add");
	},
	// pass the parameters user_group_id, user_id to the 1014 page.
	editdata(row)
	{
		this.$LogButtonEvent("1013","Edit");
		this.$LogMethodIN("1013","editdata");
		//  Change CK for backlog ID 1605
        this.dialogTableVisible = false;
		this.Errortext="";

			var EditDetails = {
			user_group_id:row.user_group_id,
			user_group_name:row.user_group_name,
			user_id:row.user_id,
			isEdit : true
			};
			
			router.push({ name: "1014",params:{Details : EditDetails} });
			this.$LogMethodOut("1013","editdata");
	},
	// csv file upload function 
	successonsubmit()
	{
		this.$LogButtonEvent("1013","UploadCSV");
		this.$LogMethodIN("1013","successonsubmit");
		if(this.$refs.upload.uploadFiles == 0){
			this.Errortext="CSVファイルを選択してください。";
		}else{
         var fileName = this.$refs.upload.uploadFiles[0]["name"];
		 this.Errortext="";
         if(fileName.split(".").pop() != 'csv'){//check if file extension is csv
            this.Errortext="CSVファイルを選択してください。";
         }else{
			// 2023/03/27  #14161  START
			this.Buttonpressed= 1;
			// 2023/03/27  #14161  END
            this.Errortext="";
            var csv_file=this.$refs.upload.uploadFiles[0]["raw"];
			let formData = new FormData();
            formData.append('csv_file', csv_file);
            this.$store.dispatch('communication1013/uploadCsvFile',formData).then(()=>{
				//  Change CK for backlog ID 1605
				if(this.getuploadrespstatus == 0){
					this.$alert(this.getsuccessresponseMessage, "確認", {
                  confirmButtonText: 'OK',
				})
				// 2023/03/27  #14161  START
				this.Buttonpressed= 0;
				// 2023/03/27  #14161  END
				}else{
					// 2023/03/27  #14161  START
					this.Buttonpressed= 0;
					// 2023/03/27  #14161  END
					this.dialogTableVisible = true
				}
				//Clearing the file after upload
				this.$refs.upload.uploadFiles = []
				//update the table
				this.$store.dispatch('communication1013/getSelectedDropdownDataToTable')
				.then(()=>
				{
					this.loading=false;
				})
				.catch(() => {
					this.loading = false;
				})
			});
            
         }
         
		}
		
	this.$LogMethodOut("1013","successonsubmit");		
	},
	// when click  the button csv file downloaded
	csvdownload(){
		this.$LogButtonEvent("1013","DownloadCSV");
		this.$LogMethodIN("1013","csvdownload");
		//  Change CK for backlog ID 1605
        this.dialogTableVisible = false;
        this.Errortext="";
	this.$confirm(json["1013_CSV_download_message"], json["1013_CSV_download_title"], {
		showCancelButton: true,		
		confirmButtonText: 'OK',
		cancelButtonText: 'キャンセル',
		customClass:'increase-width',
		beforeClose: (action, instance, done) => {
			if (action === 'confirm') {              										      			
				done();
				var user_group_details = {}
				//If drop down is selected
				if(this.form.value){
					user_group_details.user_group_name = this.form.value
				}
				this.$store.dispatch('communication1013/downloadUserRegisterList',user_group_details).then(() => {
					//After the Ajax call finished check if status is error for showing alert
					var status = this.getCsvDownloadErrStatus;
					var msgdetail = this.getCsvDownloadErrmsgDetail;
					if(status == "1")
					{
						this.$alert(msgdetail,"更新", {  confirmButtonText: 'OK',  })
					}
					else
					{
						console.log("else");
					}
				});
			} 
			else 
			{				
				done();
			}
		}
	});
	this.$LogMethodOut("1013","csvdownload");
	},
	// when changing the user group list dropdown details and get the selected value
	handleChange($event){
	this.$LogButtonEvent("1013","UserGroup");
	this.$LogMethodIN("1013","handleChange");
	//  Change CK for backlog ID 1605
    this.dialogTableVisible = false;
    this.Errortext="";
		for(var i=0; i<this.getdropdownResult1013.length;i++){
			if($event == this.getdropdownResult1013[i].user_group_name){
			this.select_option_keyvalue = this.getdropdownResult1013[i]["user_group_id"];
			}
		}
		this.$LogMethodOut("1013","handleChange");
	},
	// send the selected user group list from dropdown and pass the parameter
	sendDropdownData(){
		this.$LogButtonEvent("1013","Search");
		this.$LogMethodIN("1013","sendDropdownData");
		//  Change CK for backlog ID 1605
        this.dialogTableVisible = false;
        this.Errortext="";
		var DropdownDetails = {};
        if(this.form.value != '')
        {
            DropdownDetails. user_group_id = this.form.value;
        }

        this.loading=true;
		this.$store.dispatch('communication1013/getSelectedDropdownDataToTable',DropdownDetails).then(()=>{
			this.loading=false;
		}).catch(() => {
			this.loading = false;
		})
		this.$LogMethodOut("1013","sendDropdownData");
	},
},
	computed: {
		...mapGetters("situation1013", [
			"getTableResult1013",
			"getcheck",
			"getEditUser",
			"getdropdownResult1013",
			"getresponseMessage",
			"getDeleteResponseMsg",
			"getCsvDownloadErrStatus",
			"getCsvDownloadErrmsgDetail",
			"csvuploadErrorList",
			"getuploadrespstatus",
         "getsuccessresponseMessage"
		])
	}, 
	mounted() {
	//Get table articles during page load
	this.loading=true;
	this.$store.dispatch('communication1013/getDropdownData').then(()=>{
		this.loading=false;
	}).catch(() => {
            this.loading = false;
		});
	this.$store.dispatch('communication1013/getSelectedDropdownDataToTable').then(()=>{
		this.loading=false;
	}).catch(() => {
            this.loading = false;
          });
	
    
 
 },
  beforeCreate(){
		//Common.Session.CheckSessionExists_IfExpired_GoToLogout();
  },
	created(){
	//For the screen Title
     document.title = "ユーザー一覧画面";
	}
	
};
</script>

<style scoped>
@import "1013.css";
</style>